import { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';

const useGuestParameters = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [guestData, setGuestData] = useState({
    guestId: null,
    guestName: null,
    phone: null,
    invitationType: null,
    numberOfGuests: null,
    coupleNames: null,
    weddingDate: null,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    try {
      const guestId = searchParams?.get('guestId');
      // Support ?to= (primary), ?guest= (vindingmiracles-style), ?name= (fallback)
      const toParam = searchParams?.get('to');
      const guestParam = searchParams?.get('guest');
      const nameParam = searchParams?.get('name');
      const guestName = toParam || guestParam || nameParam;
      const invitationType = searchParams?.get('invitation_type') || searchParams?.get('type') || 'standard';
      const phone = searchParams?.get('phone');
      const numberOfGuests = parseInt(searchParams?.get('guests') || '0', 10) || null;
      const coupleNames = searchParams?.get('couple');
      const weddingDate = searchParams?.get('date');

      // Don't require guestId if ?to= or ?name= is provided
      if (!guestId && !guestName && (location?.pathname === '/wedding-invitation-display' || location?.pathname?.match(/^\/w\/[^/]+$/))) {
        setGuestData(prev => ({
          ...prev,
          isLoading: false,
          error: 'Missing guest identification',
        }));
        return;
      }

      setGuestData({
        guestId: guestId || null,
        guestName: guestName ? decodeURIComponent(guestName) : null,
        phone: phone || null,
        invitationType,
        numberOfGuests,
        coupleNames: coupleNames ? decodeURIComponent(coupleNames) : null,
        weddingDate: weddingDate || null,
        isLoading: false,
        error: null,
      });
    } catch (error) {
      setGuestData(prev => ({
        ...prev,
        isLoading: false,
        error: 'Failed to process guest parameters',
      }));
    }
  }, [searchParams, location?.pathname]);

  const updateGuestData = (updates) => {
    setGuestData(prev => ({
      ...prev,
      ...updates,
    }));
  };

  return {
    ...guestData,
    updateGuestData,
  };
};

export default useGuestParameters;